import { render } from "./customerLayout.vue?vue&type=template&id=eeccd96e&ts=true"
import script from "./customerLayout.vue?vue&type=script&lang=ts"
export * from "./customerLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__